import React from 'react';
import _isNil from 'lodash/isNil';
import _isNumber from 'lodash/isNumber';
import PropTypes from 'prop-types';
import { LocalizedPrice } from 'intl/LocalizedComponents';
import mPriceRule from 'models/cpm/priceRule';
import { cpmPriceRuleDataShape } from 'constants/PropTypesShapes';

const Amount = ({ amount, defaultValue, priceRule }) => {
  let amountToDisplay;
  if (_isNil(amount)) {
    if (_isNumber(defaultValue)) {
      amountToDisplay = mPriceRule.displayAmount(defaultValue);
    } else {
      amountToDisplay = defaultValue;
    }
  } else {
    amountToDisplay = mPriceRule.displayAmount(amount);
  }

  if (_isNil(priceRule) || !_isNumber(amountToDisplay)) {
    return (
      <React.Fragment>
        {amountToDisplay}
      </React.Fragment>
    );
  }

  return (
    <LocalizedPrice
      currency={priceRule.currency}
      value={amountToDisplay}
    />
  );
};

Amount.propTypes = {
  amount: PropTypes.number,
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  priceRule: cpmPriceRuleDataShape,
};

Amount.defaultProps = {
  amount: null,
  defaultValue: '-',
  priceRule: null,
};

module.exports = Amount;



// WEBPACK FOOTER //
// ./components/finance/Amount.js